import moment from 'moment';
import { message } from 'antd';
import * as usersServices from '../services/users';
import omit from 'lodash/omit';
import get from 'lodash/get';
import dataProvince from '../components/DataMapVN/province.json';
import dataDistrict from '../components/DataMapVN/district.json';
import dataWard from '../components/DataMapVN/ward.json';

const RESOURCE = 'users';
const transfromDocument = (record) => {
  if (record.created) {
    const createdAt = record.created;
    record.created = moment.unix(createdAt);
  }
  if (record.updated_at) {
    const updatedAt = record.updated_at;
    record.updated_at = moment.unix(updatedAt);
  }
  if (record.province) {
    const provinceName = dataProvince.RECORDS.find(i => i.id == record.province);
    record.provinceName = (provinceName || {}).name;
  }
  if (record.district) {
    const districtName = dataDistrict.RECORDS.find(i => i.id == record.district);
    record.districtName = (districtName || {}).name;
  }
  if (record.ward) {
    const wardName = dataWard.RECORDS.find(i => i.id == record.ward);
    record.wardName = (wardName || {}).name;
  }
  if (record.avatar && Array.isArray( record.avatar)) {
    record.avatar = record.avatar && record.avatar.length > 0
      ? record.avatar.filter(i => i && i !== '').map((i,idx) => ({
        uid: `${record.id}${idx + 1}`,
        name: `${record.name}-${idx}` || '',
        status: 'done',
        url: i,
      }))
      : [];
  }else if(record.avatar && typeof record.avatar === 'string'){
    record.avatar = [{
      uid: `${record.id}`,
      name: `${record.name}` || '',
      status: 'done',
      url: record.avatar,
    }]
  }
  if(record.birth) {
    const birth = record.birth;
    record.birth = moment.unix(birth);
  }
  return record;
};

export default {
  namespace: 'users',

  state: {
    data: {
      list: [],
      pagination: {
        anchor: '',
        listAnchor: {
          1: ''
        }
      },
    },
    submitting: false,
    formTitle: '',
    formID: '',
    formVisible: false,
    formData: {},
  },

  effects: {
    *fetch({ payload, callback }, { call, put }) {
      let list = [];
      try {
        const response = yield call(usersServices.getList, payload);
        // console.log('*fetch -> response %o', response);
        if (response) {

          if (response.users) {
            list = response.users.map(item => {
              transfromDocument(item);
              return item;
            });
          }
          yield put({
            type: 'save',
            payload: {
              list,
              pagination: {
                total: response.total,
                anchor: get(response, ["anchor"], ""),
                listAnchor: {
                  [((payload && payload.current) || 1) + 1]: get(response, ["anchor"], "")
                }
              }
            },
          });
        }
      } catch (error) {
        console.log('*fetch -> error', error);
      }
      if (callback) {
        callback(list);
      }
    },

    *loadForm({ payload, callback }, { put }) {
      yield put({
        type: 'changeFormVisible',
        payload: true,
      });

      yield [
        put({
          type: 'saveFormType',
          payload: payload.type,
        }),
        put({
          type: 'saveFormID',
          payload: '',
        })
      ];
      if (payload.type === 'A') {
        yield [
          put({
            type: 'saveFormTitle',
            payload: 'Thêm mới',
          }),
          put({
            type: 'saveFormData',
            payload: {
              status: '1'
            },
          }),
        ];
      }
      else if (payload.type === 'E') {
        yield [
          put({
            type: 'saveFormTitle',
            payload: "Chỉnh sửa",
          }),
          put({
            type: 'saveFormID',
            payload: payload.id,
          }),
          put({
            type: 'fetchForm',
            payload: {
              id: payload.id
            },
          }),
        ];
      }
      if (callback) {
        callback();
      }
    },


    *fetchForm({ payload, callback }, { call, put }) {
      let response;
      try {
        response = yield call(usersServices.get, payload.id, payload);
        if (response)
          transfromDocument(response);
        yield [
          put({
            type: 'saveFormData',
            payload: response,
          }),
        ];
      } catch (error) {
        console.log('*fetch -> error', error);
      }
      if (callback) {
        callback(response);
      }
    },

    *submit({ payload, callback }, { call, put, select }) {
      yield put({
        type: 'changeSubmitting',
        payload: true,
      });

      const params = { ...payload };
      const formType = yield select(state => state.users.formType);

      let success = false;
      let response;
      try {
        if (formType === 'E') {
          const id = yield select(state => state.users.formID);
          if (!params.id) {
            params.id = id;
          }
          response = yield call(usersServices.update, id, params);
          success = true;
        } else {
          const partner = yield select(state => state.auth.partner);
          response = yield call(usersServices.create, params, (partner || {}).id || 'undefined');
          success = true;
        }
      } catch (error) {
        success = false;
      }

      yield put({
        type: 'changeSubmitting',
        payload: false,
      });

      if (success) {
        message.success('Thành công');
        yield put({
          type: 'changeFormVisible',
          payload: false,
        });
      }
      if (callback && success) {
        callback(response);
      }
    },
  },

  reducers: {
    save(state, action) {
      let pagi = get(action.payload, ["pagination"], {});
      pagi = omit(pagi, ["listAnchor"]);
      const aPagi = get(action.payload, "pagination", {});
      const sPagi = get(state.data, "pagination", {});
      const listAnchor = Object.assign({},
        get(aPagi, "listAnchor", {}),
        get(sPagi, "listAnchor", {})
      );
      const pagination = Object.assign({},
        sPagi,
        { listAnchor },
        pagi
      );
      return {
        ...state,
        data: {
          ...state.data,
          list: action.payload.list,
          pagination
          // : {
          //   ...state.data.pagination,
          //   anchor: action.payload.pagination.anchor,
          //   total: action.payload.pagination.total,
          //   listAnchor: {
          //     ...action.payload.pagination.listAnchor,
          //     ...state.data.pagination.listAnchor,
          //   }
          // },
        },
      };
    },
    changeFormVisible(state, { payload }) {
      return { ...state, formVisible: payload };
    },
    saveFormTitle(state, { payload }) {
      return { ...state, formTitle: payload };
    },
    saveFormType(state, { payload }) {
      return { ...state, formType: payload };
    },
    saveFormID(state, { payload }) {
      return { ...state, formID: payload };
    },
    saveFormData(state, { payload }) {
      return { ...state, formData: payload };
    },
    changeSubmitting(state, { payload }) {
      return { ...state, submitting: payload };
    },
  },
};
